import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { ProjectionScreenReport } from "../../../../../service/report";
import { Icon } from "antd";

interface ActivityProps {
    activityData: ProjectionScreenReport;
}

export default function Activity({ activityData }: ActivityProps) {
    const {
        signInCount,
        randomCount,
        voteCount,
        exerciseCount,
        paperCount,
        groupTaskCount
    } = activityData;
    const [count, setCount] = useState(0);

    useEffect(() => {
        setCount(
            signInCount +
                randomCount +
                voteCount +
                exerciseCount +
                paperCount +
                groupTaskCount
        );
    }, [activityData]);

    return (
        <div className={style.root}>
            <div className={style.activity}>
                <div className={style.subtitle}>教学活动（{count}）</div>
                <div className={style.container}>
                    <div className={classNames(style.card, style["signIn"])}>
                        <div className={style.title}>发起签到</div>
                        <div className={style.count}>
                            {activityData?.signInCount}
                            <span className={style.unit}>次</span>
                        </div>
                        <div className={style.detail}>
                            出勤率
                            <span className={style.percent}>
                                {activityData?.signInParticipation}{" "}
                            </span>
                        </div>
                    </div>
                    <div className={classNames(style.card, style["rollCall"])}>
                        <div className={style.title}>随机选人</div>
                        <div className={style.count}>
                            {activityData?.randomCount}
                            <span className={style.unit}>个</span>
                        </div>
                        <div className={style.detail}>
                            标签语个数
                            <span className={style.percent}>
                                {activityData?.titleCount}{" "}
                            </span>
                        </div>
                    </div>
                    <div className={classNames(style.card, style["vote"])}>
                        <div className={style.title}>发起投票</div>
                        <div className={style.count}>
                            {activityData?.voteCount}
                            <span className={style.unit}>次</span>
                        </div>
                        <div className={style.detail}>
                            参与率
                            <span className={style.percent}>
                                {activityData?.voteParticipation}{" "}
                            </span>
                        </div>
                    </div>
                    <div className={classNames(style.card, style["exercise"])}>
                        <div className={style.title}>发布练习</div>
                        <div className={style.count}>
                            {activityData?.exerciseCount}
                            <span className={style.unit}>个</span>
                        </div>
                        <div className={style.detail}>
                            参与率
                            <span className={style.percent}>
                                {activityData?.exerciseParticipation}{" "}
                            </span>
                        </div>
                    </div>
                </div>
                <div className={style.container}>
                    <div className={classNames(style.card, style["homework"])}>
                        <div className={style.title}>发布作业</div>
                        <div className={style.count}>
                            {activityData?.paperCount}
                            <span className={style.unit}>个</span>
                        </div>
                        <div className={style.detail}>
                            参与率
                            <span className={style.percent}>
                                {activityData?.paperParticipation}{" "}
                            </span>
                        </div>
                    </div>
                    <div className={classNames(style.card, style["task"])}>
                        <div className={style.title}>发布小组活动数</div>
                        <div className={style.count}>
                            {activityData?.groupTaskCount}
                            <span className={style.unit}>个</span>
                        </div>
                        <div className={style.detail}>
                            参与率
                            <span className={style.percent}>
                                {activityData?.groupTaskParticipation}
                            </span>
                        </div>
                    </div>
                    <div
                        className={classNames(
                            style.card,
                            style.newCard,
                            style["task"]
                        )}>
                        <div className={style.left}>
                            <Icon type="snippets" theme="twoTone" />
                        </div>
                        <div>
                            <div className={style.title}>发布问卷数</div>
                            <div className={style.count}>
                                {activityData?.questionnaireCount}
                                <span className={style.unit}>个</span>
                            </div>
                            <div className={style.detail}>
                                参与率
                                <span className={style.percent}>
                                    {activityData?.questionnaireParticipation}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
